export const countryAbbvToName = {
  'AF':'Afghanistan',
  'AL':'Albania',
  'DZ':'Algeria',
  'AS':'American Samoa',
  'AD':'Andorra',
  'AO':'Angola',
  'AI':'Anguilla',
  'AG':'Antigua and Barbuda',
  'AR':'Argentina',
  'AM':'Armenia',
  'AW':'Aruba',
  'AU':'Australia',
  'AT':'Austria',
  'AZ':'Azerbaijan',
  'BS':'The Bahamas',
  'BH':'Bahrain',
  'BD':'Bangladesh',
  'BB':'Barbados',
  'BY':'Belarus',
  'BE':'Belgium',
  'BZ':'Belize',
  'BJ':'Benin',
  'BM':'Bermuda',
  'BT':'Bhutan',
  'BO':'Bolivia',
  'BA':'Bosnia and Herzegovina',
  'BW':'Botswana',
  'BR':'Brazil',
  'VG':'British Virgin Islands',
  'BN':'Brunei',
  'BG':'Bulgaria',
  'BF':'Burkina Faso',
  'BI':'Burundi',
  'KH':'Cambodia',
  'CM':'Cameroon',
  'CA':'Canada',
  'CV':'Cape Verde',
  'KY':'Cayman Islands',
  'CF':'Central African Republic',
  'TD':'Chad',
  'CL':'Chile',
  'CN':'China',
  'CX':'Christmas Island',
  'CC':'Cocos (Keeling) Islands',
  'CO':'Colombia',
  'KM':'Comoros',
  'CG':'Republic of the Congo',
  'CK':'Cook Islands',
  'CR':'Costa Rica',
  'CI':"Cote d'Ivoire",
  'HR':'Croatia',
  'CU':'Cuba',
  'CY':'Cyprus',
  'CZ':'Czech Republic',
  'DK':'Denmark',
  'DJ':'Djibouti',
  'DM':'Dominica',
  'DO':'Dominican Republic',
  'EC':'Ecuador',
  'EG':'Egypt',
  'SV':'El Salvador',
  'GQ':'Equatorial Guinea',
  'ER':'Eritrea',
  'EE':'Estonia',
  'ET':'Ethiopia',
  'FK':'Falkland Islands',
  'FO':'Faroe Islands',
  'FJ':'Fiji',
  'FI':'Finland',
  'FR':'France',
  'GF':'French Guiana',
  'PF':'French Polynesia',
  'GA':'Gabon',
  'GM':'The Gambia',
  'GE':'Georgia',
  'DE':'Germany',
  'GH':'Ghana',
  'GI':'Gibraltar',
  'GR':'Greece',
  'GL':'Greenland',
  'GD':'Grenada',
  'GP':'Guadeloupe',
  'GU':'Guam',
  'GT':'Guatemala',
  'GN':'Guinea',
  'GW':'Guinea-Bissau',
  'GY':'Guyana',
  'HT':'Haiti',
  'VA':'Holy See (Vatican City)',
  'HN':'Honduras',
  'HU':'Hungary',
  'IS':'Iceland',
  'IN':'India',
  'ID':'Indonesia',
  'IR':'Iran',
  'IQ':'Iraq',
  'IE':'Ireland',
  'IL':'Israel',
  'IT':'Italy',
  'JM':'Jamaica',
  'JP':'Japan',
  'JO':'Jordan',
  'KZ':'Kazakhstan',
  'KE':'Kenya',
  'KI':'Kiribati',
  'KP':'North Korea',
  'KR':'South Korea',
  'KW':'Kuwait',
  'KG':'Kyrgyzstan',
  'LA':'Laos',
  'LV':'Latvia',
  'LB':'Lebanon',
  'LS':'Lesotho',
  'LR':'Liberia',
  'LY':'Libya',
  'LI':'Liechtenstein',
  'LT':'Lithuania',
  'LU':'Luxembourg',
  'MK':'North Macedonia',
  'MG':'Madagascar',
  'MW':'Malawi',
  'MY':'Malaysia',
  'MV':'Maldives',
  'ML':'Mali',
  'MT':'Malta',
  'IM':'Isle of Man',
  'MH':'Marshall Islands',
  'MQ':'Martinique',
  'MR':'Mauritania',
  'MU':'Mauritius',
  'YT':'Mayotte',
  'MX':'Mexico',
  'FM':'Federated States of Micronesia',
  'MD':'Moldova',
  'MC':'Monaco',
  'MN':'Mongolia',
  'MS':'Montserrat',
  'MA':'Morocco',
  'MZ':'Mozambique',
  'MM':'Myanmar (Burma)',
  'NA':'Namibia',
  'NR':'Nauru',
  'NP':'Nepal',
  'NL':'Netherlands',
  'AN':'Netherlands Antilles',
  'NC':'New Caledonia',
  'NZ':'New Zealand',
  'NI':'Nicaragua',
  'NE':'Niger',
  'NG':'Nigeria',
  'NU':'Niue',
  'NF':'Norfolk Island',
  'MP':'Northern Mariana Islands',
  'NO':'Norway',
  'OM':'Oman',
  'PK':'Pakistan',
  'PW':'Palau',
  'PS':'Palestinian Territory',
  'PA':'Panama',
  'PG':'Papua New Guinea',
  'PY':'Paraguay',
  'PE':'Peru',
  'PH':'Philippines',
  'PN':'Pitcairn Islands',
  'PL':'Poland',
  'PT':'Portugal',
  'PR':'Puerto Rico',
  'QA':'Qatar',
  'RE':'Reunion',
  'RO':'Romania',
  'RU':'Russia',
  'RW':'Rwanda',
  'KN':'Saint Kitts and Nevis',
  'LC':'Saint Lucia',
  'PM':'Saint Pierre and Miquelon',
  'VC':'Saint Vincent and the Grenadines',
  'SM':'San Marino',
  'ST':'Sao Tome and Principe',
  'SA':'Saudi Arabia',
  'SN':'Senegal',
  'SC':'Seychelles',
  'SL':'Sierra Leone',
  'SG':'Singapore',
  'SK':'Slovakia',
  'SI':'Slovenia',
  'SB':'Solomon Islands',
  'SO':'Somalia',
  'ZA':'South Africa',
  'ES':'Spain',
  'LK':'Sri Lanka',
  'SD':'Sudan',
  'SR':'Suriname',
  'SJ':'Svalbard',
  'SZ':'Eswatini',
  'SE':'Sweden',
  'CH':'Switzerland',
  'SY':'Syria',
  'TW':'Taiwan',
  'TJ':'Tajikistan',
  'TZ':'Tanzania',
  'TH':'Thailand',
  'TG':'Togo',
  'TK':'Tokelau',
  'TO':'Tonga',
  'TT':'Trinidad and Tobago',
  'TN':'Tunisia',
  'TR':'Turkey',
  'TM':'Turkmenistan',
  'TC':'Turks and Caicos Islands',
  'TV':'Tuvalu',
  'UG':'Uganda',
  'UA':'Ukraine',
  'AE':'United Arab Emirates',
  'GB':'United Kingdom',
  'US':'United States',
  'UM':'United States Minor Outlying Islands',
  'UY':'Uruguay',
  'UZ':'Uzbekistan',
  'VU':'Vanuatu',
  'VE':'Venezuela',
  'VN':'Vietnam',
  'VI':'Virgin Islands',
  'WF':'Wallis and Futuna',
  'EH':'Western Sahara',
  'WS':'Western Samoa',
  'YE':'Yemen',
  'CD':'Democratic Republic of the Congo',
  'ZM':'Zambia',
  'ZW':'Zimbabwe',
  'HK':'Hong Kong',
  'MO':'Macau',
  'AQ':'Antarctica',
  'BV':'Bouvet Island',
  'IO':'British Indian Ocean Territory',
  'TF':'French Southern and Antarctic Lands',
  'HM':'Heard Island and McDonald Islands',
  'SH':'Saint Helena',
  'GS':'South Georgia and the South Sandwich Islands',
  'GG':'Guernsey',
  'RS':'Serbia',
  'BL':'Saint Barthélemy',
  'ME':'Montenegro',
  'JE':'Jersey',
  'CW':'Curaçao',
  'MF':'Saint Martin',
  'SX':'Sint Maarten',
  'TL':'Timor-Leste',
  'SS':'South Sudan',
  'AX':'Åland Islands',
  'BQ':'Bonaire',
  'XK':'Republic of Kosovo'
};

export const countryNameToAbbv = {
  'afghanistan':'AF',
  'albania':'AL',
  'algeria':'DZ',
  'american samoa':'AS',
  'andorra':'AD',
  'angola':'AO',
  'anguilla':'AI',
  'antigua and barbuda':'AG',
  'argentina':'AR',
  'armenia':'AM',
  'aruba':'AW',
  'australia':'AU',
  'austria':'AT',
  'azerbaijan':'AZ',
  'the bahamas':'BS',
  'bahrain':'BH',
  'bangladesh':'BD',
  'barbados':'BB',
  'belarus':'BY',
  'belgium':'BE',
  'belize':'BZ',
  'benin':'BJ',
  'bermuda':'BM',
  'bhutan':'BT',
  'bolivia':'BO',
  'bosnia and herzegovina':'BA',
  'botswana':'BW',
  'brazil':'BR',
  'british virgin islands':'VG',
  'brunei':'BN',
  'bulgaria':'BG',
  'burkina faso':'BF',
  'burundi':'BI',
  'cambodia':'KH',
  'cameroon':'CM',
  'canada':'CA',
  'cape verde':'CV',
  'cayman islands':'KY',
  'central african republic':'CF',
  'chad':'TD',
  'chile':'CL',
  'china':'CN',
  'christmas island':'CX',
  'cocos (keeling) islands':'CC',
  'colombia':'CO',
  'comoros':'KM',
  'republic of the congo':'CG',
  'cook islands':'CK',
  'costa rica':'CR',
  "cote d'ivoire":'CI',
  'croatia':'HR',
  'cuba':'CU',
  'cyprus':'CY',
  'czech republic':'CZ',
  'denmark':'DK',
  'djibouti':'DJ',
  'dominica':'DM',
  'dominican republic':'DO',
  'ecuador':'EC',
  'egypt':'EG',
  'el salvador':'SV',
  'equatorial guinea':'GQ',
  'eritrea':'ER',
  'estonia':'EE',
  'ethiopia':'ET',
  'falkland islands':'FK',
  'faroe islands':'FO',
  'fiji':'FJ',
  'finland':'FI',
  'france':'FR',
  'french guiana':'GF',
  'french polynesia':'PF',
  'gabon':'GA',
  'the gambia':'GM',
  'georgia':'GE',
  'germany':'DE',
  'ghana':'GH',
  'gibraltar':'GI',
  'greece':'GR',
  'greenland':'GL',
  'grenada':'GD',
  'guadeloupe':'GP',
  'guam':'GU',
  'guatemala':'GT',
  'guinea':'GN',
  'guinea-bissau':'GW',
  'guyana':'GY',
  'haiti':'HT',
  'holy see (vatican city)':'VA',
  'honduras':'HN',
  'hungary':'HU',
  'iceland':'IS',
  'india':'IN',
  'indonesia':'ID',
  'iran':'IR',
  'iraq':'IQ',
  'ireland':'IE',
  'israel':'IL',
  'italy':'IT',
  'jamaica':'JM',
  'japan':'JP',
  'jordan':'JO',
  'kazakhstan':'KZ',
  'kenya':'KE',
  'kiribati':'KI',
  'north korea':'KP',
  'south korea':'KR',
  'kuwait':'KW',
  'kyrgyzstan':'KG',
  'laos':'LA',
  'latvia':'LV',
  'lebanon':'LB',
  'lesotho':'LS',
  'liberia':'LR',
  'libya':'LY',
  'liechtenstein':'LI',
  'lithuania':'LT',
  'luxembourg':'LU',
  'north macedonia':'MK',
  'madagascar':'MG',
  'malawi':'MW',
  'malaysia':'MY',
  'maldives':'MV',
  'mali':'ML',
  'malta':'MT',
  'isle of man':'IM',
  'marshall islands':'MH',
  'martinique':'MQ',
  'mauritania':'MR',
  'mauritius':'MU',
  'mayotte':'YT',
  'mexico':'MX',
  'federated states of micronesia':'FM',
  'moldova':'MD',
  'monaco':'MC',
  'mongolia':'MN',
  'montserrat':'MS',
  'morocco':'MA',
  'mozambique':'MZ',
  'myanmar (burma)':'MM',
  'namibia':'NA',
  'nauru':'NR',
  'nepal':'NP',
  'netherlands':'NL',
  'netherlands antilles':'AN',
  'new caledonia':'NC',
  'new zealand':'NZ',
  'nicaragua':'NI',
  'niger':'NE',
  'nigeria':'NG',
  'niue':'NU',
  'norfolk island':'NF',
  'northern mariana islands':'MP',
  'norway':'NO',
  'oman':'OM',
  'pakistan':'PK',
  'palau':'PW',
  'palestinian territory':'PS',
  'panama':'PA',
  'papua new guinea':'PG',
  'paraguay':'PY',
  'peru':'PE',
  'philippines':'PH',
  'pitcairn islands':'PN',
  'poland':'PL',
  'portugal':'PT',
  'puerto rico':'PR',
  'qatar':'QA',
  'reunion':'RE',
  'romania':'RO',
  'russia':'RU',
  'rwanda':'RW',
  'saint kitts and nevis':'KN',
  'saint lucia':'LC',
  'saint pierre and miquelon':'PM',
  'saint vincent and the grenadines':'VC',
  'san marino':'SM',
  'sao tome and principe':'ST',
  'saudi arabia':'SA',
  'senegal':'SN',
  'seychelles':'SC',
  'sierra leone':'SL',
  'singapore':'SG',
  'slovakia':'SK',
  'slovenia':'SI',
  'solomon islands':'SB',
  'somalia':'SO',
  'south africa':'ZA',
  'spain':'ES',
  'sri lanka':'LK',
  'sudan':'SD',
  'suriname':'SR',
  'svalbard':'SJ',
  'eswatini':'SZ',
  'sweden':'SE',
  'switzerland':'CH',
  'syria':'SY',
  'taiwan':'TW',
  'tajikistan':'TJ',
  'tanzania':'TZ',
  'thailand':'TH',
  'togo':'TG',
  'tokelau':'TK',
  'tonga':'TO',
  'trinidad and tobago':'TT',
  'tunisia':'TN',
  'turkey':'TR',
  'turkmenistan':'TM',
  'turks and caicos islands':'TC',
  'tuvalu':'TV',
  'uganda':'UG',
  'ukraine':'UA',
  'united arab emirates':'AE',
  'united kingdom':'GB',
  'united states':'US',
  'united states minor outlying islands':'UM',
  'uruguay':'UY',
  'uzbekistan':'UZ',
  'vanuatu':'VU',
  'venezuela':'VE',
  'vietnam':'VN',
  'virgin islands':'VI',
  'wallis and futuna':'WF',
  'western sahara':'EH',
  'western samoa':'WS',
  'yemen':'YE',
  'democratic republic of the congo':'CD',
  'zambia':'ZM',
  'zimbabwe':'ZW',
  'hong kong':'HK',
  'macau':'MO',
  'antarctica':'AQ',
  'bouvet island':'BV',
  'british indian ocean territory':'IO',
  'french southern and antarctic lands':'TF',
  'heard island and mcdonald islands':'HM',
  'saint helena':'SH',
  'south georgia and the south sandwich islands':'GS',
  'guernsey':'GG',
  'serbia':'RS',
  'saint barthélemy':'BL',
  'montenegro':'ME',
  'jersey':'JE',
  'curaçao':'CW',
  'saint martin':'MF',
  'sint maarten':'SX',
  'timor-leste':'TL',
  'south sudan':'SS',
  'aland islands':'AX',
  'bonaire':'BQ',
  'republic of kosovo':'XK'
};
